
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"notifications.title.error":"Fehler","notifications.title.warning":"Warnung"},"en":{"notifications.title.error":"Error","notifications.title.warning":"Warning"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();